import { useState, Dispatch, SetStateAction } from "react";
import { GBP } from "../types/Listing";

export interface ModalState {
  // Details
  detailsOpen: boolean;
  detailsGBP: GBP | null;
  openDetails: (g: GBP) => void;
  closeDetails: () => void;

  // Reviews
  reviewsModalOpen: boolean;
  reviewsFicheId: number | undefined;
  reviewsLocationName: string | undefined;
  openReviews: (ficheId?: number, locationName?: string) => void;
  closeReviews: () => void;
  // raw setters — match handleOpenReviews(g, setOpen, setName, setId) signature
  setReviewsModalOpen: Dispatch<SetStateAction<boolean>>;
  setReviewsLocationName: Dispatch<SetStateAction<string | undefined>>;
  setReviewsFicheId: Dispatch<SetStateAction<number | undefined>>;

  // Performance
  perfLocationName: string | undefined;
  perfFicheName: string | undefined;
  openPerformance: (locationName: string, ficheName?: string) => void;
  closePerformance: () => void;
  setPerfLocationName: Dispatch<SetStateAction<string | undefined>>;
  setPerfFicheName: Dispatch<SetStateAction<string | undefined>>;

  assignTarget: string | null;
  openAssign: (target: string) => void;
  closeAssign: () => void;

  photosModalOpen: boolean;
  addPhotoOpen: boolean;
  selectedGBPForPhotos: GBP | null;
  openPhotos: (g: GBP) => void;
  closePhotos: () => void;
  openAddPhoto: () => void;
  closeAddPhoto: () => void;

postsModalOpen: boolean;
  addPostOpen: boolean;
  selectedGBPForPosts: GBP | null;
  openPosts: (g: GBP) => void;
  closePosts: () => void;
  openAddPost: () => void;
  closeAddPost: () => void;
}

export const useListingModals = (): ModalState => {
  // Details
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [detailsGBP,  setDetailsGBP]  = useState<GBP | null>(null);

  // Reviews
  const [reviewsModalOpen,    setReviewsModalOpen]    = useState(false);
  const [reviewsFicheId,      setReviewsFicheId]      = useState<number | undefined>();
  const [reviewsLocationName, setReviewsLocationName] = useState<string | undefined>();

  // Performance
  const [perfLocationName, setPerfLocationName] = useState<string | undefined>();
  const [perfFicheName,    setPerfFicheName]    = useState<string | undefined>();

  // Assign
  const [assignTarget, setAssignTarget] = useState<string | null>(null);

  // Photos
  const [photosModalOpen,     setPhotosModalOpen]     = useState(false);
  const [addPhotoOpen,        setAddPhotoOpen]        = useState(false);
  const [selectedGBPForPhotos, setSelectedGBPForPhotos] = useState<GBP | null>(null);

  // Posts
  const [postsModalOpen,     setPostsModalOpen]     = useState(false);
  const [addPostOpen,        setAddPostOpen]        = useState(false);
  const [selectedGBPForPosts, setSelectedGBPForPosts] = useState<GBP | null>(null);

  return {
    // Details
    detailsOpen, detailsGBP,
    openDetails:  (g) => { setDetailsGBP(g); setDetailsOpen(true); },
    closeDetails: ()  => setDetailsOpen(false),

    // Reviews
    reviewsModalOpen, reviewsFicheId, reviewsLocationName,
    openReviews: (ficheId, locationName) => {
      setReviewsFicheId(ficheId);
      setReviewsLocationName(locationName);
      setReviewsModalOpen(true);
    },
    closeReviews: () => setReviewsModalOpen(false),
    setReviewsModalOpen,
    setReviewsLocationName,
    setReviewsFicheId,

    // Performance
    perfLocationName, perfFicheName,
    openPerformance:  (loc, fiche) => { setPerfLocationName(loc); setPerfFicheName(fiche); },
    closePerformance: ()           => { setPerfLocationName(undefined); setPerfFicheName(undefined); },
    setPerfLocationName,
    setPerfFicheName,

    // Assign
    assignTarget,
    openAssign:  (target) => setAssignTarget(target),
    closeAssign: ()       => setAssignTarget(null),

    // Photos
    photosModalOpen, addPhotoOpen, selectedGBPForPhotos,
    openPhotos:   (g) => { setSelectedGBPForPhotos(g); setPhotosModalOpen(true); },
    closePhotos:  ()  => setPhotosModalOpen(false),
    openAddPhoto: ()  => { setPhotosModalOpen(false); setAddPhotoOpen(true); },
    closeAddPhoto:()  => setAddPhotoOpen(false),

    // Posts
    postsModalOpen, addPostOpen, selectedGBPForPosts,
    openPosts:   (g) => { setSelectedGBPForPosts(g); setPostsModalOpen(true); },
    closePosts:  ()  => setPostsModalOpen(false),
    openAddPost: ()  => { setPostsModalOpen(false); setAddPostOpen(true); },
    closeAddPost:()  => setAddPostOpen(false),
  };
};